export default __webpack_public_path__ + "static/media/home.a7c4e282.svg";